import { apiUtils, appConstants } from 'apis/common';
import { Instrument } from 'defs/instrument';

export async function derivativesApi(token: number): Promise<Instrument[]> {
  const resp = await apiUtils.callApi(appConstants.derivativesUrl(token), 'GET', null);
  const data: Instrument[] = resp.data?.payload;
  return data;
}
